import React from "react"
import { Link, graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import PostBy from '../components/postBy'
import {Helmet} from "react-helmet";

const BlogPostTemplate = ({ data, pageContext, location }) => {
  const post = data.markdownRemark
  const siteTitle = data.site.siteMetadata.title
  const siteUrl = data.site.siteMetadata.siteUrl
  const { previous, next } = pageContext
  const postUrl = `${siteUrl}${post.fields.slug}`
  const bannerUrl = post.frontmatter.banner ? `${siteUrl}/${post.frontmatter.banner}` : undefined
  const wordCount = post.html.replace(/<[^>]*>/g, '').split(/\s+/).filter(Boolean).length

  const JsonLdData = {
    "@context": "https://schema.org",
    "@type": "TechArticle",
    "author": {
      "@type": "Person",
      "name": "Lenvin Gonsalves",
      "url": siteUrl
    },
    "datePublished": post.frontmatter.date,
    "dateModified": post.frontmatter.date,
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": postUrl
    },
    "headline": post.frontmatter.title,
    "description": post.frontmatter.description || post.excerpt,
    "publisher": {
      "@type": "Person",
      "name": "Lenvin Gonsalves"
    },
    "wordCount": wordCount,
  }

  if (bannerUrl) {
    JsonLdData.image = {
      "@type": "ImageObject",
      "url": bannerUrl,
    }
  }

  const returnFormatDate = (date) => {
    const parsedDate = new Date();
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return parsedDate.toLocaleDateString("en-US", options)
  }

  return (
    <Layout location={location} title={siteTitle}>
      <SEO
        title={post.frontmatter.title}
        description={post.frontmatter.description || post.excerpt}
        image={bannerUrl}
        pathname={post.fields.slug}
        isArticle={true}
      />
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(JsonLdData)}
        </script>
      </Helmet>
      <ol itemScope itemType="https://schema.org/BreadcrumbList" className='breadcrumb'>
        <li itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
          <Link itemProp="item" to="/">
            <span itemProp="name">Home</span>
          </Link>
          <meta itemProp="position" content="1" />
        </li>
        {' > '}
        <li itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
          <Link itemProp="item" to="/posts">
            <span itemProp="name">Posts</span>
          </Link>
          <meta itemProp="position" content="2" />
        </li>
        {' > '}
        <li itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
          <span itemProp="name">{`${post.frontmatter.title.slice(0,30)}...`}</span>
          <meta itemProp="position" content="3" />
        </li>
      </ol>
      <article>
        <header>
          {post.frontmatter.banner && <img src={post.frontmatter.banner} className='bannerImage' alt={post.frontmatter.title} />}
          <h1>{post.frontmatter.title}</h1>
          <PostBy date={returnFormatDate(post.frontmatter.date)}/>
        </header>
        <section dangerouslySetInnerHTML={{ __html: post.html }} />
      </article>
      <nav className='blog-nav'>
        {previous && (
          <Link to={previous.fields.slug} rel="prev">
            &larr; Previous
          </Link>
        )}
        {next && (
          <Link to={next.fields.slug} rel="next">
            Next &rarr;
          </Link>
        )}
      </nav>
    </Layout>
  )
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
        siteUrl
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      html
      fields {
        slug
      }
      frontmatter {
        title
        date
        description
        banner
      }
    }
  }
`
